import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow, CSelect } from "@coreui/react";
import { useRemissionNoteFormContext } from "../context/RemissionNoteFormContext";
import { TRANSPORT_VEHICLE_DOCUMENT_TYPE_CHOICES } from "../../../models/transport";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const RemissionNoteFormVehicleSection: React.FC = () => {
  const {
    remissionNoteRef,
    errors,
    ontransportVehicleTypeChange,
    onTransportVehicleBrandChange,
    onTransportVehicleDocumentTypeCodeChange,
    onTransportVehicleDocumentNumberChange,
    onTransportVehicleRegistrationNumberChange,
  } = useRemissionNoteFormContext();

  return (
    <>
      <SectionDivider icon="fa-car" label="Vehículo" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Tipo de Vehículo:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportVehicleType
                  : ""
              }
              onChange={ontransportVehicleTypeChange}
              placeholder="Tipo"
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("transportVehicleType", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Marca:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportVehicleBrand
                  : ""
              }
              onChange={onTransportVehicleBrandChange}
              placeholder="Marca"
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("transportVehicleBrand", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Tipo de Documentación:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportVehicleDocumentTypeCode
                  : undefined
              }
              onChange={onTransportVehicleDocumentTypeCodeChange}
            >
              <option value={""}>-----</option>
              {Array.from(
                TRANSPORT_VEHICLE_DOCUMENT_TYPE_CHOICES.entries()
              ).map((entry) => {
                return (
                  <option key={entry[0]} value={entry[0]}>
                    {entry[1]}
                  </option>
                );
              })}
            </CSelect>
            <FieldErrors
              errors={
                getFieldErrors("transportVehicleDocumentType", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Documento Vehículo:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportVehicleDocumentNumber
                  : ""
              }
              onChange={onTransportVehicleDocumentNumberChange}
              placeholder="Documento de Vehículo"
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("transportVehicleDocumentNumber", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Matrícula:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.transportVehicleRegistrationNumber
                  : ""
              }
              onChange={onTransportVehicleRegistrationNumberChange}
              placeholder="Matrícula"
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("transportVehicleRegistrationNumber", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};
